import Vue from 'vue'
import { startCase } from 'lodash'

Vue.filter('capitalize', v => '' + v.charAt(0).toUpperCase() + v.slice(1))

Vue.filter('startCase', startCase)

Vue.filter('trim', v => ('' + v).trim())
